import styles from './style.module.scss';
import {
  CardStackData,
  CardStackItem,
} from 'tenants';
import Image from 'components/image-loader/image';

import { useTranslation } from 'next-i18next';

type CardProps = {
  index: number;
  card: CardStackItem;
};

function Card({ card, index }: CardProps) {
  const { t } = useTranslation();
  return (
    <div
      key={card.title}
      className={styles.card}
      style={{ '--index': index, backgroundColor: card.backgroundColor, color: card.textColor } as React.CSSProperties}>
      <div className={styles.cardRow}>
        <div className={styles.leftSection}>
          <div className={styles.cardNumber}>{`0${index + 1}`}</div>
        </div>
        <div className={styles.middleSection}>
          <h3>{t(card.title)}</h3>
          <p>{t(card.description)}</p>
        </div>
        <div className={styles.rightSection}>
          {card.imageSrc && (
            <Image src={card.imageSrc} alt={t(card.imageAlt)} isVisible={!!card.imageSrc} />
          )}
        </div>
      </div>
    </div>
  );
}

export type CardStackProps = {
  stack: CardStackData;
};

function CardStack({ stack }: CardStackProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h2>{t(stack.title)}</h2>
      </div>
      <div className={styles.component}>
        {stack.content.map((card, index) => (
          <Card key={card.title} card={card} index={index} />
        ))}
      </div>
    </div>
  );
}

export default CardStack;